import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function ProjectHistoryStats() {
  const statsData = [
    { name: 'Cập nhật', value: 98, color: '#3b82f6' },
    { name: 'Thêm mới', value: 62, color: '#10b981' },
    { name: 'Phê duyệt', value: 45, color: '#06b6d4' },
    { name: 'Thanh toán', value: 20, color: '#f43f5e' },
    { name: 'Báo cáo', value: 10, color: '#f59e0b' },
    { name: 'Khác', value: 10, color: '#94a3b8' },
  ];

  return (
    <DonutLegendChart
      title="Thống kê lịch sử"
      centerValue={245}
      centerLabel="Tổng thay đổi"
      data={statsData}
      total={245}
    />
  );
}
